import { ILayerBehavior, ITableLayerProps } from '@/version-types';
import { collectTableLayerFonts } from '../utils/table';

type Behaviors = Pick<ILayerBehavior, 'getTextInfo' | 'isTextEditable'>;

export const createFontBehaviors = (frameworkIdentity: string) => {
    const behaviors: Behaviors = {
        isTextEditable: () => true,

        getTextInfo: (layer) => collectTableLayerFonts(layer.data as ITableLayerProps),
    };

    return behaviors;
};
